<template>
  <div>
    <h1 class="mx-4 my-16 lg:m-20 text-lg md:text-xl font-serif border-b border-b2c-red-300 w-11/12 md:w-full"> {{$t('login.verify')}}! </h1>
    <div class="flex w-full justify-end" v-if="redirect==='/checkout'">
      <button
        @click="goToCheckout()"
        class="hover:bg-b2c-red-300 hover:text-white text-b2c-grey-600 p-2 px-3 rounded border border-b2c-grey-600">
          {{$t('checkout.comeBack')}} </button>
    </div>
    <div class="flex flex-col m-6">
        <label>{{ $t('signin.receive') }}</label>
        <button @click="resendEmail()" :class="isLoading ? 'loader' : ''"
          class="p-2 bg-gray-300 w-40 shadow-md rounded-md text-sm mt-4 hover:bg-b2c-red-300 hover:text-white">
            {{$t('signin.resend')}}
        </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    redirect() {
      return this.$route.query.redirect;
    },
  },

  methods: {
    goToCheckout() {
      this.$router.push('/checkout');
    },

    resendEmail() {
      this.isLoading = true;
      axios.post('/email/resend').then(() => {
        this.isLoading = false;
        this.createNotification('success', this.$t('notifications.emailSendAgain'));
      }).catch(() => {
        this.isLoading = false;
        this.createNotification('error', `${this.$t('notifications.errorTryAgain')}`);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #615A57;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
